<template>
  <div>
    <Dialog
      width="770px"
      titleAlign="left"
      :visible="renderData.train_visible"
      @close="closeDialog"
      customClass="train-model-dialog"
    >
      <div
        :class="`${createRenderType}-train-model-container train-model-container`"
      >
        <div class="title">{{ $t("create.train_your_custom_model") }}</div>
        <div class="desc">{{ $t("create.create_musical_preferences") }}</div>
        <div v-for="(item, index) in productList" :key="index">
          <div class="price-card flex">
            <div class="require flex1 flex-row-center">
              <div class="info">
                <div
                  class="flex-row-center"
                  v-for="citem in item.common_desc"
                  :key="citem"
                >
                  {{ citem }}
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="price flex-column-center">
              <div class="flex">
                <div class="unit">{{ priceFalg }}</div>
                <div class="num">
                  {{ item.new_price }}
                </div>
              </div>
              <div class="payment">{{ $t("create.one_time_payment") }}</div>
            </div>
          </div>
          <div class="start-btn">
            <Button
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '48px',
                '--background':
                  'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover':
                  'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
                '--fontColorHover': '#000',
              }"
              :loading="isLoading"
              @click="handleStart(item)"
            >
              <span>{{ $$t("create.start_training_now") }}</span>
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { defineProps, reactive, watch, ref, getCurrentInstance, defineEmits} from "vue";
import { storeToRefs } from "pinia";
import { $$t } from "@/i18n/i18n.js";
import message from "@/components/functionCallComponent/message.jsx";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { checkoutCredit } from "@/api/api/apiCredit.js";
import globleConfig, { ModuleOpenStateControl } from "@/config/config.js";
import { isMobileDevice } from "@/utils/tools";
import { handlePayMoney } from "@/utils/pay.js";
import { useRoute, useRouter } from "vue-router"
import useUserDataStore from "@/store/userDataStore";

const Router = useRouter();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const createLayoutStore = useCreateLayoutStore();
const { createRenderType, createEditMode } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible", "paySuccess", "payFail"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  productList: {
    type: Object,
    default: () => [],
  },
});

const renderData = reactive({
  train_visible: false,
});
const userDataStore = useUserDataStore();

const isLoading = ref(false);
const priceFalg = globleConfig.appname != "Mureka" ? "¥" : "$";

watch(
  () => {
    return props.visible;
  },
  (val) => {
    renderData.train_visible = props.visible;
    if (val) {
      globalProperties.logCustomEvent("subcribe_show", {
        membership_source1: "create",
        membership_source2:
          createEditMode.value == "easy"
            ? "create_basic_persionalized_mode"
            : "create_advance_persionalized_mode",
      });
    }
  },
  {
    immediate: true,
  }
);

watch(
  () => {
    return renderData.train_visible;
  },
  () => {
    emits("update:visible", renderData.train_visible);
  },
  {
    immediate: true,
  }
);

const closeDialog = () => {
  renderData.train_visible = false;
};

const handleStart = (item) => {
  const channel =
    globleConfig.appname == "Mureka"
      ? "stripe"
      : `wechat_${
          ModuleOpenStateControl.pay.openMobile && isMobileDevice()
            ? "h5"
            : "native"
        }`;
  const product_id = item?.[`${channel}_info`]?.product_id;
  globalProperties.logCustomEvent("subcrirbe_sub_click", {
    product_id,
    membership_source1: "create",
    membership_source2:
      createEditMode.value == "easy"
        ? "create_basic_persionalized_mode"
        : "create_advance_persionalized_mode",
    details: userDataStore.userInfo?.discount?.discount_percent 
      ? String(userDataStore.userInfo.discount.discount_percent) + '_off' 
      : "",
    type: String(userDataStore.userInfo?.discount?.discount_type ?? ""),    
  });
  if(globleConfig.appname == "Mureka"){
    Router.push({
      name: "payment",
      query: {
        pageType: 'lora',
      },
    });
    return
  }

  isLoading.value = true;
  // const product_id = item?.stripe_info?.product_id;
  // const product_id = item?.[`${channel}_info`]?.product_id;
  checkoutCredit({
    product_id,
    channel,
    return_url: `${window.location.origin}/create?is_create_model=1`,
    membership_source1: "create",
    membership_source2:
      createEditMode.value == "easy"
        ? "create_basic_persionalized_mode"
        : "create_advance_persionalized_mode",
  })
    .then((res) => {
      if (res.code == 200) {
        // closeDialog();
        const { order_id, jump_url } = res.data;

        if (globleConfig.appname != "Mureka") {
          handlePayMoney(
            {
              totalPrice: item.new_price,
              order_id,
              isCredit: true,
              wechat_native_url: jump_url,
            },
            paySuccess,
            () => {
              payFail();
            }
          );
          return;
        }
        if (jump_url) {
          closeDialog();
          window.location.href = jump_url;
        }
      } else if (res.code == 6348) {
        message.error({
          position: "top",
          content: $$t("create.payment_complete_refresh"),
        });
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const paySuccess = () => {
  emits("paySuccess");
  closeDialog();
};

const payFail = () => {
  emits("payFail");
};
</script>

<style lang="scss" scoped>
.train-model-dialog {
  .train-model-container {
    padding: 0px 40px 40px;
    .title {
      font-size: 28px;
      font-weight: bold;
      line-height: 32px;
      color: #fff;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
    }
    .select {
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      gap: 20px;
      .select-item {
        display: flex;
        align-items: center;
        justify-content: left;
        gap: 8px;
        color: #fff;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-image: url("@/assets/img/credit/ic-select.png");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
        }
        &.light {
          // color: #fff;
          i {
            background-image: url("@/assets/img/credit/ic-selected.png");
          }
        }
      }
    }
    .price-card {
      position: relative;
      box-sizing: border-box;
      height: 172px;
      margin-top: 12px;
      border: 2px solid transparent;
      border-radius: 16px;
      padding: 16px;
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: inherit;
        padding: 2px;
        background: linear-gradient(108deg, #4fdeff 0%, #e675ff 100%);
        -webkit-mask: linear-gradient(white, white) content-box,
          linear-gradient(white, white);
        -webkit-mask-composite: destination-out;
        mask-composite: exclude;
      }
      .require {
        width: 330px;
        .name {
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          line-height: 24px;
        }
        .info {
          // margin-top: 20px;
          font-size: 16px;
          font-weight: normal;
          line-height: 20px;
          color: #fff;
          div {
            align-items: flex-start;
            margin-bottom: 12px;
            &:last-of-type {
              margin-bottom: 0;
            }
            &::before {
              content: "";
              margin-top: 9px;
              flex-shrink: 0;
              width: 6px;
              height: 6px;
              background: #fff;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: url("@/assets/img/lora/line.png");
        background-size: 100% 100%;
        margin: 0 16px;
      }
      .price {
        padding: 0 32px;
        .unit {
          font-size: 56px;
          font-weight: bold;
          background: linear-gradient(
            94deg,
            #4fdeff -36%,
            #d9f8ff 52%,
            #e675ff 129%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .num {
          margin-left: 8px;
          font-size: 68px;
          font-weight: bold;
          line-height: 100%;
          background: linear-gradient(
            94deg,
            #4fdeff -36%,
            #d9f8ff 52%,
            #e675ff 129%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .payment {
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          color: #fff;
          margin-top: 12px;
        }
      }
    }
    .start-btn {
      margin-top: 24px;
      :deep(.el-button .el-icon.is-loading) {
        background-image: url("@/assets/img/loading-mini-white-3x.png") !important;
      }
    }
  }
  .mobile-train-model-container {
    padding: 0px 20px 20px;
    .title {
      padding-right: 50px;
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
    }
    .desc {
      margin-top: 8px;
      font-size: 12px;
      line-height: 16px;
      color: rgba(255, 255, 255, 0.8);
    }
    .select {
      margin-top: 10px;
    }
    .price-card {
      flex-direction: column;
      height: max-content;
      padding: 20px;
      .require {
        width: 100%;
        .info {
          // margin-top: 12px;
          font-size: 12px;
          line-height: 18px;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        margin: 20px 0;
        background: url("@/assets/img/lora/line-mobile.png");
        background-size: 100% 100%;
      }
      .price {
        flex-direction: row;
        justify-content: center;
        padding: 0;
        .unit {
          font-size: 39px;
        }
        .num {
          font-size: 48px;
        }
        .payment {
          margin: 0 0 0 12px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>